<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Registrar Proveedor
            <router-link :to="{ name: 'Proveedores' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.nombreProveedor.$model"
                  :isValid="checkIfValid('nombreProveedor')"
                  label="Nombre del proveedor:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 100 caracteres"
                />
              </CCol>
            </CRow>

            <ExtraConfigInput
              title=""
              parametro="proveedores_atributos_extras"
              v-model="fieldsExtra"
              @config="config => fieldsExtraConfig = config"
              @onValid="v=>valid=v"
            />

            <!-- <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Ubicación:</label>
                <v-select
                  v-model="ubicacion"
                  :options="ubicaciones"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona una ubicación"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow> -->

            <!-- Ultimos cambios, en espera del back, solo descomentar -->

            <!-- <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Ubicaciones:</label>
                <div class="d-flex margin-multi align-items-center">
                  <multiselect
                    v-model="multi"
                    :options="ubicaciones"
                    :multiple="true"
                    label="label"
                    :loading="isLoadingPage"
                    track-by="label"
                    placeholder="Selecciona uno o varias ubicaciones"
                  >
                    <template #no-options>Sin resultados.</template>
                  </multiselect>
                  <transition name="fade">
                    <div v-show="multi && multi.length" @click="cleanMulti()">
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Empresa:</label>
                <v-select
                  v-model="empresa"
                  :options="empresas"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona una empresa"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Puesto:</label>
                <v-select
                  v-model="puesto"
                  :options="puestos"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona un puesto"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                  </template>
                  <template #no-options>Sin resultados.</template>
                </v-select>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.costo.$model"
                  :isValid="checkIfValid('costo')"
                  label="Costo"
                  placeholder="Costo.."
                  type="number"
                  append=".00"
                  prepend="$"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  v-model="unidad"
                  :value.sync="$v.unidad.$model"
                  :isValid="checkIfValid('unidad')"
                  label="Unidad:"
                  placeholder="Unidad..."
                  invalidFeedback="Campo requerido, debe tener al menos 1 caracter y maximo 5 caracteres"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  v-model="costo_extra"
                  label="Costo extra"
                  placeholder="Costo extra.."
                  type="number"
                  append=".00"
                  prepend="$"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput v-model="unidad_extra" label="Unidad extra:" placeholder="Unidad extra..." />
              </CCol>
            </CRow>

            <CRow>
              <CCol class="mb-3 d-flex flex-column" sm="12" md="9" lg="9">
                <label>Foto proveedor:</label>
                <input
                  ref="imgTr"
                  @change="inputFile"
                  type="file"
                  label="Unidad extra:"
                  placeholder="Image..."
                />
              </CCol>
            </CRow>
            <img v-show="url" class="mb-2" width="50" height="50" :src="url" :alt="urlName" />

            <div class="mb-3">
              <label class="mr-2">Suspendido:</label>
              <CSwitch @update:checked="toggleSuspendido()" class="mx-1" color="primary" variant="3d" />
            </div> -->

            <!-- Fields dinamycs;  note: will be can abstract to component for N times and use en another component form -->
            <!-- <h5 class="mb-3">Datos adicionales del proveedor</h5>
            <CRow v-for="(field,index) in fieldsExtraConfig" :key="index" >
              <CCol sm="12" md="9" lg="9" >
                <label>{{field.etiqueta}}:</label>
                <CInput
                  v-if="field.tipo !== 'select'"
                  v-model="fieldsExtra[field.nombre]"
                  :type="field.tipo"
                  :placeholder="field.etiqueta"
                />
                <select v-if="field.tipo === 'select'" class="form-control" v-model="fieldsExtra[field.nombre]">
                  <option v-for="(option, index) in field.config" :key="index"
                  :value="option.value"> {{option.label}} </option>
                </select>
              </CCol>
            </CRow> -->
            <!-- End fields dinamycs -->

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CAlert
                  fade
                  color="success"
                  class="my-1"
                  :show.sync="currentAlertCounter"
                >Guardado con éxito.</CAlert>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Proveedores' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>

            <CButton @click="addProveedor()" class="px-4 mx-3 btn-lg" color="success">
              <div v-if="isLoading">
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>

      <CModal
        size="sm"
        title="Proveedor"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >{{ error }}</CModal>
    </CRow>
  </div>
</template>

<script>

import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

import "vue-select/dist/vue-select.css";

import ExtraConfigInput from './../../customComponents/ExtraConfigInput.vue'

export default {
  name: "NuevoProveedor",
  components: {
    ExtraConfigInput
  },
  computed: {
    isValidProveedor() {
      return !this.$v.nombreProveedor.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },

  methods: {
    inputFile(e) {
      let reader = new FileReader();
      this.url = "";
      this.urlName = "";

      reader.onload = file => {
        this.url = file.target.result;
        this.urlName = e.target.files[0].name;
      };

      reader.readAsDataURL(e.target.files[0]);
      //  this.$emit('input', this.value);
    },
    toggleSuspendido() {
      this.suspendido = !this.suspendido
    },
    addProveedor() {

      let agregarProveedor = "";
      this.validateProveedor();

      // clean numbers extra fileds

      this.fieldsExtraConfig.forEach(indexField => {
        if (indexField.tipo === "number") {
          this.fieldsExtra[indexField.nombre] =
            Number(this.fieldsExtra[indexField.nombre]) || 0;
        }
        if (indexField.tipo === "text") {
          this.fieldsExtra[indexField.nombre] =
            this.fieldsExtra[indexField.nombre] || "";
        }
      });

      if (this.isValidProveedor) {
        debugger
        // Ultimos cambios, en espera del back, solo descomentar
        // if (!this.multi && !this.multi.length) {
        // if (!this.ubicaciones) {
        //   this.error = "El campo ubicación es obligatorio";
        //   this.warningModal = true;
        //   return;
        // }
        // // Ultimos cambios, en espera del back, solo descomentar
        // if (!this.empresa) {
        //   this.error = "El campo empresa es obligatorio";
        //   this.warningModal = true;
        //   return;
        // }
        // if (!this.puesto) {
        //   this.error = "El campo puesto es obligatorio";
        //   this.warningModal = true;
        //   return;
        // }

        this.isLoading = true;

        agregarProveedor = {
          schema: "proveedores",
          payload: {
            nombre: this.nombreProveedor,
            ...(this.fieldsExtraConfig.length > 0)?{extras: this.fieldsExtra}:{},
          }
        }

        this.$store
          .dispatch("customActualizarHTTP", agregarProveedor)
          .then(() => {
            //
            this.currentAlertCounter = 6;
            // this.$router.push({ name: "Proveedores" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })
          .finally(() => {
            this.isLoading = false;
          });

      }
    },
    addProveedorFull() {
      const newUbicaciones =
        this.multi &&
        this.multi.map(ubi => {
          return ubi.value;
        });
      // Ultimos cambios, en espera del back, solo descomentar
       let agregarProveedor = "";
      if (this.fieldsExtraConfig.length > 0) {
        agregarProveedor = {
          schema: "proveedores",
          payload: {
            nombre: this.nombreProveedor,
            ubicaciones: newUbicaciones,
            empresa_id: this.empresa && this.empresa.value,
            puesto_id: this.puesto && this.puesto.value,
            costo: this.costo ? Number(this.costo) : 0,
            costo_extra: this.costo ? Number(this.costo_extra) : 0,
            unidad: this.unidad,
            unidad_extra: this.unidad_extra,
            suspendido: this.suspendido ? true : false,
            extras : this.fieldsExtra
          }
        }
      }else{
        agregarProveedor = {
          schema: "proveedores",
          payload: {
            nombre: this.nombreProveedor,
            ubicaciones: newUbicaciones,
            empresa_id: this.empresa && this.empresa.value,
            puesto_id: this.puesto && this.puesto.value,
            costo: this.costo ? Number(this.costo) : 0,
            costo_extra: this.costo ? Number(this.costo_extra) : 0,
            unidad: this.unidad,
            unidad_extra: this.unidad_extra,
            suspendido: this.suspendido ? true : false
          }
        }
      }

      this.isLoading = true;
      this.$store
        .dispatch("customActualizarHTTP", agregarProveedor)
        .then(() => {
          //
          this.currentAlertCounter = 6;
          // this.$router.push({ name: "Proveedores" });
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.isLoading = false;
        });
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateProveedor() {
      this.$v.nombreProveedor.$touch();
      this.$v.costo.$touch();
      this.$v.unidad.$touch();
      // this.$v.equivalencia_6oz.$touch();
    },

    cleanMulti() {
      this.multi = [];
    }
  },

  created() {

  },

  mixins: [validationMixin],
  validations: {
    nombreProveedor: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(50)
    },

    unidad: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(5)
    },
    costo: {
      required
    }
  },

  data() {
    return {
      date: null,
      multi: null,
      nombreProveedor: "",
      ubicacion: null,
      ubicaciones: [],
      // Ultimos cambios, en espera del back, solo descomentar
      empresa: null,
      empresas: [],
      puesto: null,
      puestos: [],
      dia: null,
      dias: [
        { value: 0, label: "Lunes" },
        { value: 1, label: "Martes" },
        { value: 2, label: "Miércoles" },
        { value: 3, label: "Jueves" },
        { value: 4, label: "Viernes" },
        { value: 5, label: "Sabado" },
        { value: 6, label: "Domingo" }
      ],
      costo: null,
      cantidad: "",
      unidad: "",
      costo_extra: null,
      unidad_extra: "",
      url: "",
      urlName: "",
      warningModal: false,
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      error: "",
      fieldsExtraConfig : [],
      fieldsExtra : {},
      suspendido: false
    };
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  width: 100%;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
